import IconButton from '@mui/material/IconButton';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('jwt');
    navigate('/login');
  };

  return (
    <IconButton
      onClick={handleLogout}
      sx={{
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 1000,
        bgcolor: 'background.paper',
        '&:hover': {
          bgcolor: 'action.hover',
        },
      }}
    >
      <LogoutIcon />
    </IconButton>
  );
};

export default LogoutButton; 